export default {
      id: "sites-graphic-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#sites-graphic",
      toString: function () {
        return this.url;
      }
    }